import { enUS, nl, nlBE, fr, de } from "react-day-picker/locale";
import { SupportedLocale } from 'types';


export function getDateRangePickerLocale(lang: SupportedLocale): Record<string, any> {
    switch (lang) {
        case 'nl':
            return nl;
        case 'nl-BE':
        case 'nl-be':
            return nlBE;
        case 'fr':
        case 'fr-BE':
            return fr;
        case 'de':
            return de
        default:
            return enUS
    }
}
